var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19065 12.1218L6.19064 12.1218L1.50314 7.43436C1.33229 7.26351 1.33229 6.98649 1.50314 6.81564C1.67399 6.64479 1.95101 6.64479 2.12186 6.81564L5.20895 9.90273L6.0625 10.7563V9.54917V1.1875C6.0625 0.94588 6.25838 0.75 6.5 0.75C6.74162 0.75 6.9375 0.94588 6.9375 1.1875V9.54917V10.7563L7.79105 9.90273L10.8782 6.81565C11.049 6.64479 11.326 6.64479 11.4968 6.81565C11.6677 6.9865 11.6677 7.2635 11.4968 7.43435L11.4968 7.43436L6.80936 12.1218L6.80935 12.1218C6.6385 12.2927 6.3615 12.2927 6.19065 12.1218ZM0.75 16.1876C0.75 15.946 0.945884 15.7501 1.1875 15.7501H11.8125C12.0541 15.7501 12.25 15.946 12.25 16.1876C12.25 16.4292 12.0541 16.6251 11.8125 16.6251H1.1875C0.945885 16.6251 0.75 16.4292 0.75 16.1876Z",
    fill: "#24292E",
    stroke: "#2E260A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2b089226d0ecf60d0c72d3dab9d1494c.svg";
export { ForwardRef as ReactComponent };